import { useQueryClient } from "@tanstack/react-query";
import type { DisableMfaRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useDisableMfa() {
  const queryClient = useQueryClient();

  return useApiMutation("post", "/auth/mfa/disable", {
    notify: { error: false },
    invalidate: () => {
      queryClient.invalidateQueries({ queryKey: ["get", "/users/me"] });
    },
    mapVariables: (body: DisableMfaRequestDto) => ({ body }),
  });
}
